import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'loading-icon',
    templateUrl: './loading-icon.component.html',
    styleUrls: ['./loading-icon.component.scss']
})
export class LoadingIconComponent implements OnInit {

    @Input()

    public btnLabel: string = '';

    @Input()
    public iconClass: string = '';

    @Input()
    public loading: boolean = false;

    constructor() {
    }

    ngOnInit() {
    }

}
